export default "__VITE_ASSET__zpZNkY1o__"